<style scoped lang="less">
	// .upload-demo {
	// 	position: relative;
	// 	height: 20vh;
	// 	left: 0;
	// }
</style>


<template>
	<div>
		
		<!-- http://192.168.88.136/api/TrainEquipment/UploadImages -->
		<!-- action="http://192.168.88.136/api/Train/UploadTrainImages" -->
		<el-upload :file-list="filelists" accept=".png,.jpg" ref="upload" :action="baseurl" list-type="picture-card" :limit="1"
			:on-preview="handlePictureCardPreview" :on-success="handleSuccess" :on-remove="handleRemove" :headers="{ 'Authorization': token }">
			<i class="el-icon-plus"></i>
		</el-upload>
		<el-dialog title="修改头像" :visible.sync="dialogVisible" center width="80%">
			<div style="display: flex;align-items: center;justify-content: center;">
				<div style="display: flex;align-items: center;flex-direction: column;">
					<div style="width: 30rem;height: 30rem;">
						<vueCropper
							ref="cropper"
							:img="dialogImageUrl"
							:outputSize="option.outputSize"
							:outputType="option.outputType"
							:info="option.info"
							:full="option.full"
							:canMove="option.canMove"
							:canMoveBox="option.canMoveBox"
							:original="option.original"
							:autoCrop="option.autoCrop"
							:autoCropWidth="option.autoCropWidth"
							:autoCropHeight="option.autoCropHeight"
							:fixedBox="option.fixedBox"
							@realTime="realTime"
						></vueCropper>
					</div>
				</div>
		
				<div
					style="width: 320px;
						height: 240px;
						display: flex;
						justify-content: space-evenly;
						align-items: center;
						margin-left: 1rem;"
				>
					<img :src="corappurl" alt=""  style="width: 100%;height: 100%;"/>
					
				</div>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button @click="dialogVisible = false">取 消</el-button>
				<el-button type="primary" @click="changeheadimg()">确 定</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>	
	import {
		DeleteTrainEquipmentImages,
		TrainEquipmentUploadImages
	} from "@/request/api/trainroom/trainroom.js"
	import {
		setbaseurl
	} from "@/utils/utils.js"
	
	import { VueCropper } from 'vue-cropper';

	export default {
		props:{
			filelist:Array
		},
		data() {
			return {
				dialogImageUrl: '',
				dialogVisible: false,
				disabled: false,
				filelists:[],
				baseurl:"",
				token:"Bearer "+localStorage.getItem("token"),
				option: {
					img: '', // 裁剪图片的地址
					info: true, // 裁剪框的大小信息
					outputSize: 0.8, // 裁剪生成图片的质量
					outputType: 'jpeg', // 裁剪生成图片的格式
					canScale: true, // 图片是否允许滚轮缩放
					autoCrop: true, // 是否默认生成截图框
					autoCropWidth: 320, // 默认生成截图框宽度
					autoCropHeight: 240, // 默认生成截图框高度
					fixedBox: true, // 固定截图框大小 不允许改变
					fixed: true, // 是否开启截图框宽高固定比例
					fixedNumber: [1, 0], // 截图框的宽高比例
					full: true, // 是否输出原图比例的截图
					canMoveBox: true, // 截图框能否拖动
					original: true, // 上传图片按照原始比例渲染
					centerBox: true, // 截图框是否被限制在图片里面
					infoTrue: true // true 为展示真实输出图片宽高 false 展示看到的截图框宽高
				},
				corappurl: '',
				newfilenow: ''
				
			};
		},
		mounted() {
			this.baseurl = setbaseurl() + '/TrainEquipment/UploadImages'
			this.filelists = this.filelist
		},
		watch:{
			filelist(val){
				this.filelists = val
			}
		},
		components:{
			VueCropper
		},
		methods: {
			// 真实图片
			realTime(data) {
				// console.log(data);
				this.previews = data;
				let _this = this;
				this.$refs.cropper.getCropBlob(async data1 => {
					let formData = new FormData();
					if (data1) {
						var timestamp = new Date().getTime() + '.jpg';
						const newFile = new window.File([data1], timestamp);
						var src = window.URL.createObjectURL(newFile);
						_this.newfilenow = newFile;
						_this.corappurl = src;
					}
				});
			},
			changeheadimg(){
				// console.log(this.$refs.upload,"上传")
				this.$refs.upload.uploadFiles[0].url = this.corappurl
				var form_data = new FormData();
				form_data.append('file', this.newfilenow);
				TrainEquipmentUploadImages(form_data).then(res=>{
					if (res.data.code == 1) {
						this.$message({
							message: res.data.msg,
							type: 'success'
						});
						this.dialogVisible = false
						this.$refs.upload.uploadFiles[0].response.data = res.data.data
						var str = ""
						this.$refs.upload.uploadFiles.forEach((item)=>{
							if(item.response.code == 1){
								str+= item.response.data+"#"
							}
						})
						str = str.slice(0,-1)
						// console.log(str)
						this.$store.commit("changetrainimg",str)
						
						// console.log(this.$store.state.trainimg,"图片地址11111")
						
					} else {
						this.$message(res.data.msg, "格式默认人为jpg/png");
					}
				})
				
			},
			
			// 上传文件列表
			handleSuccess(response, file, fileList){
				this.handlePictureCardPreview(file)
				// console.log(fileList)
				// var str = ""
				// fileList.forEach((item)=>{
				// 	if(item.response.code == 1){
				// 		str+= item.response.data+"#"
				// 	}
				// })
				// str = str.slice(0,-1)
				// // console.log(str)
				// this.$store.commit("changetrainimg",str)
				// // console.log(this.$store.state.trainimg)
			},
			
			handleRemove(file, fileList) {
				// console.log(file);
				var str1 = ""
				fileList.forEach((item)=>{
					if(item.response.code == 1){
						str1+= item.response.data+"#"
					}
				})
				let fromimgdata = new FormData();
				fromimgdata.append("filePath", file.response.data);
				
				DeleteTrainEquipmentImages(fromimgdata).then((res) => {
					// console.log(res,"删除实训室图片")
					if(res.data.code == 1){
						this.$message({
							message: res.data.msg,
							type: "success",
						});
						str1 = str1.slice(0,-1)
						this.$store.commit("changetrainimg",str1)
					}else{
						this.$message(res.data.msg);
					}
					// this.$store.commit("changeTrainPowerimg", "");
				});
				
				// console.log(this.$store.trainimg)
			},
			handlePictureCardPreview(file) {
				this.dialogImageUrl = file.url;
				this.dialogVisible = true;
			}
		}
	}
</script>

<style>
</style>
